<template>
  <!--访问外部链接页面-->
  <div class="filePreview">
    <!--------------------顶部导航---------------------->
    <div class="topNav" v-if="showNav">
          <span class='topBackBtn' @click="goBack">
            <van-icon name="arrow-left"/>
          </span>
    </div>
    <div class="iframeBox">
      <!--返回按钮-->
      <img src="../../assets/img/close.png" :class="['returnBtn',{setposition:showNav}]" @click="goBack"
           v-if="showBackBtn">
      <iframe :src="targetUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
    </div>
  </div>
</template>

<script>
import {getConfig} from '../../util/auth'

export default {
  name: 'findExternallinks',
  data () {
    return {
      showNav: false, // 是否展示导航栏
      showBackBtn: false, // 是否展示返回按钮
      targetUrl: this.$route.query.targetUrl
    }
  },
  methods: {
    // 返回聊天
    goBack () {
      this.$router.push('/')
    },
    // 是否展示返回按钮
    getConfigInfoFn () {
      let configInfo = getConfig()
      if (configInfo) {
        this.showNav = configInfo.setting.settingsShowNavigationBar
        this.showBackBtn = configInfo.setting.settingsShowBackButton
      }
    }
  },
  mounted () {
    // 是否展示返回按钮
    this.getConfigInfoFn()
  },
  beforeDestroy () {

  }
}

</script>

<style scoped>
.filePreview {
  width: 100%;
  height: 100vh;
  background-color: #f2f3f5;
  overflow: hidden;
  font-size: 15px;
}

.topNav {
  position: relative;
  background: #fff;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.iframeBox {
  width: 100%;
  height: calc(100vh - 40px)
}

.returnBtn {
  width: 25px;
  position: fixed;
  left: 2px;
  top: 2px;
  z-index: 99999;
  opacity: 0.8;
}

.setposition {
  top: 42px;
}

.topBackBtn {
  font-size: 18px;
  position: absolute;
  left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/chat/findExternallinks.vue